import React, { useEffect, useRef } from 'react';

//This hook can be used to maintain track of a prop or state and get its previous value.
const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
export default usePrevious;
